import { Form } from "react-bootstrap";

export default function SelectTopic({ topic, setTopic, topicData }) {
  const onTopicChange = (event) => {
    setTopic(event.target.value);
  };

  return (
    <>
      <h3 className="mb-3 css-dev-only-do-not-override-yp8pcc" style={{color:"white" , fontSize:"24px" , fontWeight:"600"}}>
        Topic:  
      </h3>
      <Form.Select
        style={{ width: "30%", borderRadius: "0.5rem" }}
        value={topic}
        onChange={onTopicChange}
        className="select-topic"
      >
        <option value="">Choose a topic</option>
        {topicData?.map((elem, index) => (
          <option key={index} value={elem.value}>
            {elem.label}
          </option>
        ))}
      </Form.Select>
    </>
  );
}
